<template>
  <section class="data-settings-page">
    <header class="data-settings-hero">
      <div>
        <p class="data-settings-kicker">Data Settings</p>
        <h1>Developer API</h1>
        <span>Manage product export keys and compatibility downloads.</span>
      </div>
    </header>
  <!-- <div class="my-4">
    <button class="bg-emerald-600 text-white p-4 text-xl rounded-xl">
      Download .CSV of my product data
    </button>
  </div>
  <div class="border-emerald-600 border rounded w-[max-content]">
    <div class="px-2 bg-emerald-600 text-white w-[max-content] rounded-br">
      .CSV Email Schedule
    </div>
    <div class="px-4 pb-4 pt-3">
      <div class="flex items-end mb-4">
        <span class="min-w-[max-content] mr-2">Email to:</span
        ><select class="m-0 max-w-[max-content]">
          <option disabled selected>select lab admin</option>
        </select>
      </div>
      <div class="flex items-end">
        <span class="min-w-[max-content] mr-2">Frequency:</span
        ><select class="m-0 max-w-[max-content]">
          <option>none</option>
          <option>weekly</option>
          <option>monthly</option>
        </select>
    </div>
  </div> -->
  <section class="developer-card">
    <header class="developer-card-header">
      <div>
        <p class="data-settings-kicker">Endpoint</p>
        <h2>Product Data</h2>
      </div>
      <button
        class="primary-command"
        @click="createkey = true"
      >
        <span class="material-symbols-outlined" aria-hidden="true">key</span>
        Create API Key
      </button>
    </header>

    <div class="developer-card-body">
      <div v-if="labKeys.length > 0" class="export-actions">
        <button
          class="secondary-command"
          @click="generateCSV"
          :disabled="generatingCSV"
        >
          <span class="material-symbols-outlined" aria-hidden="true">download</span>
          {{ generatingCSV ? "Generating..." : "Generate CSV" }}
        </button>
        <button
          class="secondary-command"
          @click="generateHTML"
          :disabled="generatingHTML"
        >
          <span class="material-symbols-outlined" aria-hidden="true">html</span>
          {{ generatingHTML ? "Generating..." : "Generate HTML File" }}
        </button>
      </div>

      <div class="endpoint-block">
        <span>URL</span>
        <code>
          GET
          https://api.subangstrom.com/v1/productdata?api_key=YOUR_API_KEY_HERE
        </code>
      </div>

      <div class="api-keys-block">
        <div class="api-keys-heading">
          <h2>API Keys</h2>
          <span>{{ labKeys.length }} key{{ labKeys.length === 1 ? "" : "s" }}</span>
        </div>
        <div v-if="labKeys.length === 0" class="empty-state">
          <span class="material-symbols-outlined" aria-hidden="true">vpn_key_off</span>
          <strong>No API keys created.</strong>
        </div>
        <div v-else class="api-table-shell">
          <table class="api-table">
            <thead>
              <tr>
                <th>API Key</th>
                <th>Created By</th>
                <th>Last Used</th>
                <th>IP Restriction</th>
                <th>Delete</th>
              </tr>
            </thead>
            <tbody>
              <tr :key="canonicalId(key) || index" v-for="(key, index) in labKeys">
                <td class="key-cell">
                  <code v-if="!visible[index]">
                {{ asteriskMiddle(key.apikey) }}
                  </code>
                  <code v-else>{{ key.apikey }}</code>

                  <button
                    v-if="!visible[index]"
                    type="button"
                    class="icon-command"
                    title="Show key"
                    @click="visible[index] = true"
                  >
                    <span class="material-symbols-outlined" aria-hidden="true">visibility</span>
                  </button>
                  <button
                    v-else
                    type="button"
                    class="icon-command"
                    title="Hide key"
                    @click="visible[index] = false"
                  >
                    <span class="material-symbols-outlined" aria-hidden="true">visibility_off</span>
                  </button>
                </td>
                <td>{{ key.createdBy }}</td>
                <td v-if="key.lastUsedTime">
              {{ appStore.state.cleanDate(key.lastUsedTime, true) }}
                  <span v-if="key.lastUsedIp" class="ip-pill">
                {{ key.lastUsedIp }}</span
              >
                </td>
                <td v-else>Never</td>
                <td>{{ key.ipRestricted || "None" }}</td>
                <td>
                  <button
                    class="danger-command"
                    @click="deleteKey($event, canonicalId(key))"
                  >
                    Delete
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- <div></div>
        <div v-if="showKey" class="border-emerald-600 border rounded p-2">
          12345
        </div>
        <div
          v-else
          class="border-emerald-600 border rounded p-2 cursor-pointer italic"
          @click="showKey = true"
        >
          CLICK TO SHOW KEY
        </div> -->
      </div>
    </div>
    <div v-if="createkey">
      <DisplayModal @ridfeedback="createkey = false">
        <div class="create-key-modal">
          <h2>Create API Key</h2>
          <p>
            Provide a network IP address allowed to use this key. Leave empty if
            you do not want to restrict access.
          </p>
          <input type="text" placeholder="Optional IP restriction" />

          <button
            class="primary-command"
            @click="
              (ev) => createKey(ev, ev.currentTarget.previousSibling.value)
            "
          >
            Create Key
          </button>
        </div>
      </DisplayModal>
    </div>
  </section>
  </section>
</template>
<script>
import { buildProductCsvExports } from "@/utils/productDataExports";
import { buildProductHtmlViewer } from "@/utils/productHtmlExport";

export default {
  mounted() {
    this.getLabKeys();
  },
  methods: {
    canonicalId(value) {
      if (!value) return "";
      if (typeof value === "string") return value;
      return value.id || "";
    },
    async deleteKey(ev, keyId) {
      const deleteit = confirm("Are you sure you want to delete this api key?");
      if (!deleteit) return;
      const button = ev.currentTarget;
      button.disabled = true;
      await this.appStore.dispatch("deleteItem", {
        item: "keys",
        objid: keyId,
      });

      this.getLabKeys();
      button.disabled = false;
      this.createkey = false;
    },

    async createKey(ev, ipLock) {
      const button = ev.currentTarget;
      button.disabled = true;
      await this.appStore.dispatch("createItem", {
        item: "keys",
        body: {
          ipLock,
        },
      });

      this.getLabKeys();
      button.disabled = false;
      this.createkey = false;
    },
    async getLabKeys() {
      const url = `${this.appStore.state.hostname}/api/v1/keys`;

      const request = new Request(url, {
        credentials: "include",
        method: "GET",
        headers: { "content-type": "application/json" },
      });
      const data = await fetch(request);
      const jsondata = await data.json();
      if (jsondata.data?.data) {
        this.labKeys = jsondata.data.data;
      }
    },
    asteriskMiddle(string) {
      if (string.length === 30) {
        const middleStart = 5;
        const middleEnd = 25;
        const asterisks = "*".repeat(20);
        return (
          string.slice(0, middleStart) + asterisks + string.slice(middleEnd)
        );
      } else {
        return string.length;
      }
    },
    async fetchProductData() {
      if (this.labKeys.length === 0) {
        alert("No API key available. Please create an API key first.");
        return null;
      }

      const apiKey = this.labKeys[0].apikey;
      // Use the main API server to fetch product data (with credentials to pass through)
      const url = `${this.appStore.state.hostname}/api/v1/dewars/apiproductdata`;

      console.log("Fetching from URL:", url);

      try {
        const response = await fetch(url, {
          method: "POST",
          credentials: "include",
          headers: { "content-type": "application/json" },
          body: JSON.stringify({ key: apiKey }),
        });
        console.log("Response status:", response.status);
        if (!response.ok) {
          const errorText = await response.text();
          console.error("Error response:", errorText);
          throw new Error(
            `API request failed with status ${response.status}: ${errorText}`
          );
        }
        const responseText = await response.text();
        console.log("Response text:", responseText);
        const data = JSON.parse(responseText);
        console.log("Parsed data:", data);
        return data;
      } catch (error) {
        console.error("Fetch error:", error);
        alert(`Error fetching data: ${error.message}\n\nURL: ${url}`);
        return null;
      }
    },
    async fetchProjectMap() {
      const url = `${this.appStore.state.hostname}/api/v1/projects`;

      try {
        const response = await fetch(url, {
          method: "GET",
          credentials: "include",
          headers: { "content-type": "application/json" },
        });

        if (!response.ok) {
          const errorText = await response.text();
          console.error("Projects fetch error:", errorText);
          throw new Error(`Projects request failed: ${response.status}`);
        }

        const jsondata = await response.json();
        const projects = jsondata?.data?.data || [];
        return projects.reduce((map, project) => {
          if (project?.id && project?.name) {
            map[project.id] = project.name;
          }
          return map;
        }, {});
      } catch (error) {
        console.error("Fetch project map error:", error);
        // Fallback to empty map if project fetch fails
        return {};
      }
    },
    triggerDownload(blob, filename) {
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    },
    async generateCSV() {
      this.generatingCSV = true;
      try {
        const data = await this.fetchProductData();
        console.log("CSV - Fetched data:", data);

        const products = data?.data || data?.dewars || [];

        if (!Array.isArray(products) || products.length === 0) {
          alert("No product data available");
          return;
        }

        const projectMap = await this.fetchProjectMap();
        const csvExports = buildProductCsvExports(products, { projectMap });
        const stamp = new Date().toISOString().split("T")[0];

        csvExports.forEach(({ name, content }) => {
          if (!content) {
            return;
          }
          const blob = new Blob(["\uFEFF" + content], {
            type: "text/csv;charset=utf-8",
          });
          this.triggerDownload(blob, `product_${name}_${stamp}.csv`);
        });
      } finally {
        this.generatingCSV = false;
      }
    },
    async generateHTML() {
      this.generatingHTML = true;
      try {
        const data = await this.fetchProductData();
        console.log("HTML - Fetched data:", data);

        const products = data?.data || data?.dewars || [];

        if (!Array.isArray(products) || products.length === 0) {
          alert("No product data available");
          return;
        }

        const htmlContent = buildProductHtmlViewer(products, new Date().toLocaleString());
        const stamp = new Date().toISOString().split("T")[0];

        const blob = new Blob([htmlContent], { type: "text/html" });
        this.triggerDownload(blob, `product_data_viewer_${stamp}.html`);
      } finally {
        this.generatingHTML = false;
      }
    },
  },
  data() {
    return {
      createkey: false,
      visible: [],
      showKey: false,
      labKeys: [],
      generatingCSV: false,
      generatingHTML: false,
      selectedKeyIndex: 0,
    };
  },
};
</script>
<style scoped>
.data-settings-page {
  display: grid;
  gap: 14px;
  width: 100%;
  padding: 16px;
  background: #fff;
}

.data-settings-hero,
.developer-card {
  border: 1px solid #d7e2ef;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 10px 22px rgba(15, 35, 55, 0.07);
}

.data-settings-hero {
  padding: 16px;
}

.data-settings-kicker {
  margin: 0 0 4px;
  color: #64748b;
  font-size: 0.72rem;
  font-weight: 900;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.data-settings-hero h1,
.developer-card-header h2,
.api-keys-heading h2,
.create-key-modal h2 {
  margin: 0;
  color: #0f3654;
  font-size: 1.35rem;
  font-weight: 900;
}

.data-settings-hero span,
.create-key-modal p {
  color: #64748b;
  font-size: 0.84rem;
  font-weight: 750;
}

.developer-card {
  overflow: hidden;
}

.developer-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border-bottom: 1px solid #dbe4ee;
  padding: 14px 16px;
}

.developer-card-body {
  display: grid;
  gap: 16px;
  padding: 16px;
}

.export-actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.primary-command,
.secondary-command,
.danger-command,
.icon-command {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  width: auto;
  max-width: none;
  min-height: 34px;
  height: auto;
  margin: 0;
  border-radius: 6px;
  font-size: 0.8rem;
  font-weight: 900;
  cursor: pointer;
}

.primary-command {
  border: 1px solid #0b5f82;
  background: #0b4f71;
  padding: 0 12px;
  color: #fff;
}

.secondary-command {
  border: 1px solid #cbd7e6;
  background: #f8fbff;
  padding: 0 11px;
  color: #335c8b;
}

.secondary-command:disabled {
  opacity: 0.62;
  cursor: wait;
}

.danger-command {
  min-height: 28px;
  border: 1px solid #fecaca;
  background: #fff;
  padding: 0 8px;
  color: #dc2626;
}

.icon-command {
  width: 30px;
  min-height: 30px;
  border: 1px solid #cbd7e6;
  background: #fff;
  color: #335c8b;
}

.endpoint-block {
  display: grid;
  gap: 6px;
}

.endpoint-block > span {
  color: #475569;
  font-size: 0.75rem;
  font-weight: 900;
}

.endpoint-block code {
  display: block;
  overflow-x: auto;
  border: 1px solid #cbd7e6;
  border-radius: 7px;
  background: #f8fbff;
  padding: 10px;
  color: #172033;
  white-space: nowrap;
}

.api-keys-block {
  display: grid;
  gap: 10px;
}

.api-keys-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.api-keys-heading span {
  color: #64748b;
  font-size: 0.78rem;
  font-weight: 900;
}

.api-table-shell {
  overflow-x: auto;
}

.api-table {
  width: 100%;
  min-width: 760px;
  border-collapse: separate;
  border-spacing: 0;
}

.api-table th {
  padding: 10px;
  border-bottom: 1px solid #dbe4ee;
  background: #eef3f7;
  color: #334155;
  font-size: 0.72rem;
  font-weight: 900;
  text-align: left;
  text-transform: uppercase;
}

.api-table td {
  padding: 10px;
  border-bottom: 1px solid #edf2f7;
  color: #243041;
  font-size: 0.85rem;
}

.key-cell {
  display: flex;
  align-items: center;
  gap: 8px;
}

.key-cell code {
  font-size: 0.8rem;
}

.ip-pill {
  display: inline-flex;
  margin-left: 4px;
  border-radius: 999px;
  background: #e2e8f0;
  padding: 1px 7px;
  color: #475569;
  font-size: 0.72rem;
  font-weight: 900;
}

.empty-state {
  display: grid;
  place-items: center;
  min-height: 160px;
  border: 1px dashed #cbd7e6;
  border-radius: 8px;
  color: #64748b;
}

.empty-state .material-symbols-outlined {
  color: #94a3b8;
  font-size: 36px;
}

.create-key-modal {
  display: grid;
  gap: 12px;
  max-width: 420px;
  border-radius: 8px;
  background: #fff;
  padding: 18px;
  box-shadow: 0 18px 38px rgba(15, 23, 42, 0.18);
}

.create-key-modal input {
  border: 1px solid #cbd7e6;
  border-radius: 6px;
  padding: 9px 10px;
}
</style>
